import { render, staticRenderFns } from "./ClassicCase.vue?vue&type=template&id=2661b106&scoped=true&"
import script from "./ClassicCase.vue?vue&type=script&lang=js&"
export * from "./ClassicCase.vue?vue&type=script&lang=js&"
import style0 from "./ClassicCase.vue?vue&type=style&index=0&id=2661b106&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2661b106",
  null
  
)

export default component.exports